export const STEP_ID = {
  SELECT_ORDER: 'select-order',
  PURCHASE_ORDER: 'purchase-order',
  INVOICE: 'invoice',
  PROOF_OF_ACCEPTANCE: 'proof-of-acceptance',
  REVIEW: 'review'
} as const

export type StepId = (typeof STEP_ID)[keyof typeof STEP_ID]

export const STEP_ORDER: readonly StepId[] = [
  STEP_ID.SELECT_ORDER,
  STEP_ID.PURCHASE_ORDER,
  STEP_ID.INVOICE,
  STEP_ID.PROOF_OF_ACCEPTANCE,
  STEP_ID.REVIEW
]

export const STEP_LABELS: Record<StepId, string> = {
  [STEP_ID.SELECT_ORDER]: 'Order',
  [STEP_ID.PURCHASE_ORDER]: 'Purchase Order',
  [STEP_ID.INVOICE]: 'Invoice',
  [STEP_ID.PROOF_OF_ACCEPTANCE]: 'Proof of Acceptance',
  [STEP_ID.REVIEW]: 'Review'
}
